import {
  Component,
  OnInit,
  TemplateRef,
  AfterViewInit,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {
  UsuariosService,
  AuthenticationService,
  NotificacionesPushService,
  SubastasService,
  PujasService,
  PermissionsService
} from '../_services';
import { environment } from '../../environments/environment';
import { SwPush } from '@angular/service-worker';
import { DomSanitizer } from '@angular/platform-browser';
import { isEmpty } from 'lodash';
import { OwlCarousel } from 'ngx-owl-carousel';

// así se importan los nuevos autobahn pero no son compatibles con WAMP v1
// import * as autobahn from 'autobahn-browser/autobahn.js';
declare let ab: any; // esto permite que se compile bien en dev y prod

declare let $: any;
@Component({
  selector: 'app-subastas-detalle',
  templateUrl: './subastas-detalle.component.html',
  styleUrls: ['./subastas-detalle.component.css']
})
export class SubastasDetalleComponent implements AfterViewInit, OnDestroy {
  notificacionesForm: FormGroup;
  modalRef: BsModalRef;
  loading = false;
  submitted = false;
  returnUrl: string;
  currentUserInfo = null;
  public subasta: any;
  public loteSeguido: Array<object> = [];
  public id: string;
  public cantidadUsuariosLote: string;
  public montoPuja: any;
  public ultimoMontoPuja: any;
  public ultimoPujador: any;
  public enPeriodoPuja: any;
  public enPeriodoCompraDirecta: any;
  public vendido: any;
  public precioVentaFinal: any;
  public urlYoutube: any;
  public enPeriodoAleatorio: any;
  public pujas: Array<object> = [];
  public ganador: any;
  public seguidoresLote: Array<object> = [];
  public finalizado: any;
  public ultimoRegistro: any;
  conn: any;
  subscripto = false;
  logueado = false;
  text: any = {
    Year: 'Años',
    Month: 'Meses',
    Weeks: 'Semanas',
    Days: 'd',
    Hours: 'h',
    Minutes: 'm',
    Seconds: 's',
    MilliSeconds: 'Milisegundos'
  };
  labelUltimaPuja: string;
  private indexActual: any;
  public anterior: any;
  public siguiente: any;
  public urlGoogleMaps: any;
  @ViewChild('owlElement') owlElement: OwlCarousel;

  constructor(
    public swPush: SwPush,
    private notificacionesPushService: NotificacionesPushService,
    private subastasService: SubastasService,
    public route: ActivatedRoute,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private usuariosService: UsuariosService,
    private pujasService: PujasService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private sanitizer: DomSanitizer,
    private permissionsService: PermissionsService
  ) {
    route.params.subscribe(val => {
      this.authenticationService.logueado$.subscribe(b => {
        this.logueado = b; // por ser BehaviourSubject ya devuelve automáticamente el primer valor
      });

      if (this.logueado) {
        this.currentUserInfo = JSON.parse(localStorage.getItem('currentUser'));
        this.notificacionesForm = this.formBuilder.group({
          celular: [this.currentUserInfo.celular],
          notificar_sms: [this.currentUserInfo.notificar_sms],
          notificar_email: [this.currentUserInfo.notificar_email],
          notificar_dispositivo: [this.currentUserInfo.notificar_dispositivo]
        });
      } else {
        this.notificacionesForm = this.formBuilder.group({
          celular: [''],
          notificar_sms: [false],
          notificar_email: [false],
          notificar_dispositivo: [false]
        });
      }
      this.getSubasta();
    });
  }

  public getSubasta() {
    this.id = this.route.snapshot.paramMap.get('id');
    console.log('en get subasta ' + this.id);
    this.subastasService.getSubasta(this.id).subscribe((data: object) => {
      this.subasta = data;
      this.subasta.fechaInicioPuja = this.subastasService.fechaMysqlAfechaJs(
        this.subasta.fechaInicioPuja
      );
      this.subasta.fechaFinPuja = this.subastasService.fechaMysqlAfechaJs(
        this.subasta.fechaFinPuja
      );
      if (this.subasta.activo === true) {
        if (this.logueado) {
          this.getLotesSeguidos();
        }
        this.getCantidadUsuariosLote();
        this.subscribirWebSocket(this.id, this);
        this.getPujas();
        this.getSeguidoresLote();
        // Las pujas se realizan de a 20.000
        this.montoPuja = 0;
        this.ultimoMontoPuja = this.subasta.ultimoMontoPujado;
        this.ultimoPujador = this.subasta.esUltimo;
        this.enPeriodoPuja = this.subasta.enPeriodoPuja;
        this.enPeriodoCompraDirecta = this.subasta.enPeriodoCompraDirecta;
        this.vendido = this.subasta.vendido;
        this.precioVentaFinal = this.subasta.precioVentaFinal;
        this.finalizado = this.subasta.finalizado;
        this.enPeriodoAleatorio = this.subasta.periodoAleatorio;
        this.urlYoutube = '';
        if (this.subasta.urlYoutube) {
          this.urlYoutube = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.subasta.urlYoutube
          );
        }
        this.urlGoogleMaps = '';
        if (this.subasta.latitud) {
          this.urlGoogleMaps = this.sanitizer.bypassSecurityTrustResourceUrl(
            'https://www.google.com/maps/dir/?api=1&destination=' +
            this.subasta.latitud +
            ',' +
            this.subasta.longitud
          );
        }

        if (this.subasta.ultimoMontoPujado === 0) {
          this.montoPuja = this.subasta.precioBase;
        } else {
          this.montoPuja = this.subasta.ultimoMontoPujado + 20000;
        }

        this.subastasService.ultimoResultado$.subscribe(ultimo => {
          if (!isEmpty(ultimo)) {
            this.ultimoRegistro = ultimo;
            this.indexActual = ultimo.findIndex(x => x.id === this.subasta.id);
            this.anterior = this.findDataByIndex(ultimo, this.indexActual - 1);
            this.siguiente = this.findDataByIndex(ultimo, this.indexActual + 1);
          }
        });

        this.actualizarLabel();
        /*this.subasta.precioBase = this.comma2decimalfloat(
          this.subasta.precioBase
        );*/
        // muevo aqui el evento que se disparaba en el afterviewinit, ya que primero se disparaba el afterViewInit,
        // y luego se obtenian las imagenes, por lo tanto no se armaba bien el componente carousel
        if (this.subasta.imagenes.length > 0) {
          this.subasta.imagenes.map(i => {
            i.url = environment.baseUrl + '/..' + i.url;
          });
          if (typeof this.owlElement !== 'undefined') {
            this.owlElement.to([0]);
          }
        }
      } else {
        // no tenemos imagenes del lote, pero establecemos este timeout para que funcione el carousel de los auspicios
      }
    });
  }

  private findDataByIndex(data, index) {
    for (let i = 0, l = data.length; i < l; i++) {
      if (i === index) {
        return data[index];
      }
    }
    return false;
  }

  public actualizarLabel() {
    this.labelUltimaPuja = this.ultimoPujador
      ? 'La puja es suya'
      : 'Última puja';
  }
  public getLotesSeguidos() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.subastasService
      .getLoteSeguido(this.id)
      .subscribe((data: Array<object>) => {
        if (data.length > 0) {
          this.loteSeguido = data['0'];
          if (this.logueado && this.loteSeguido !== null) {
            this.notificacionesForm = this.formBuilder.group({
              celular: [this.currentUserInfo.celular],
              notificar_sms: [this.loteSeguido['notificar_sms']],
              notificar_email: [this.loteSeguido['notificar_email']],
              notificar_dispositivo: [this.loteSeguido['notificar_dispositivo']]
            });
          }
        } else {
          this.notificacionesForm = this.formBuilder.group({
            celular: [this.currentUserInfo.celular],
            notificar_sms: [this.currentUserInfo.notificar_sms],
            notificar_email: [this.currentUserInfo.notificar_email],
            notificar_dispositivo: [this.currentUserInfo.notificar_dispositivo]
          });
        }
      });
  }

  ngAfterViewInit() {
    // inicializo aquí el carousel en vez de en el document ready.
    console.log('en sub det ngAfterViewInit');
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.notificacionesForm.controls;
  }

  onSubmit() {
    this.id = this.route.snapshot.paramMap.get('id'); // id_lote
    // stop here if form is invalid
    if (this.notificacionesForm.invalid) {
      return;
    }
    if (this.f.notificar_dispositivo.value) {
      this.subscribirAPushNotifications();
    }
    this.loading = true;
    let id_lote_seguido = null;
    if (this.loteSeguido !== undefined) {
      id_lote_seguido = this.loteSeguido['id'];
    }

    this.subastasService
      .postLoteSeguido(
        id_lote_seguido,
        this.id,
        this.f.notificar_sms.value,
        this.f.notificar_email.value,
        this.f.notificar_dispositivo.value
      )
      .pipe(first())
      .subscribe(
        data => {
          this.loteSeguido = data;
          this.modalRef.hide();
          this.getCantidadUsuariosLote();
        },
        error => {
          this.loading = false;
        }
      );
    if (this.currentUserInfo.celular !== this.f.celular.value) {
      this.usuariosService
        .postUsuariosNotificaciones(this.f.celular.value)
        .pipe(first())
        .subscribe(data => {
          this.currentUserInfo = data;
        });
    }
  }

  deleteLoteSeguido() {
    // console.log('delete lote');
    this.id = this.route.snapshot.paramMap.get('id');
    this.subastasService
      .deleteLoteSeguido(this.loteSeguido['id'])
      .subscribe((data: Array<object>) => {
        console.log('delete lote');
        this.getCantidadUsuariosLote();
        this.loteSeguido = [];
        if (this.logueado) {
          this.notificacionesForm = this.formBuilder.group({
            celular: [this.currentUserInfo.celular],
            notificar_sms: [this.currentUserInfo.notificar_sms],
            notificar_email: [this.currentUserInfo.notificar_email],
            notificar_dispositivo: [this.currentUserInfo.notificar_dispositivo]
          });
        } else {
          this.notificacionesForm = this.formBuilder.group({
            celular: [null],
            notificar_sms: [false],
            notificar_email: [false],
            notificar_dispositivo: [false]
          });
        }
      });
  }
  public getCantidadUsuariosLote() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.subastasService
      .getCantidadUsuariosLotes(this.id)
      .subscribe((data: Array<object>) => {
        this.cantidadUsuariosLote = data[0]['cantidad_lotes'];
      });
  }
  pujar() {
    console.log('pujando', this.id, this.montoPuja);
    if (!confirm('Desea enviar una puja por ' + this.montoPuja + '?')) {
      return false;
    }
    this.pujasService.postPuja(this.id, this.montoPuja).subscribe(data => {
      console.log(data);
    });
  }

  compraDirecta() {
    console.log('Compra directa ', this.id, this.subasta.precioCompraDirecta);
    if (
      !confirm(
        'Desea hacer la compra directa por ' +
        this.subasta.precioCompraDirecta +
        '?'
      )
    ) {
      return false;
    }
    this.pujasService
      .postCompraDirecta(this.id, this.subasta.precioCompraDirecta)
      .subscribe(data => {
        console.log(data);
      });
  }

  subscribirWebSocket(id_lote, that) {
    const identificador = that.currentUserInfo
      ? that.currentUserInfo.id
      : 'nadie';
    const connLocal = new ab.Session(
      environment.websocketUrl + '/' + identificador,
      function () {
        that.subscripto = true;
        console.log('Subscribiendo a' + 'lote_' + id_lote);

        connLocal.subscribe('lote_' + id_lote, function (topic, data) {
          // This is where you would add the new article to the DOM (beyond the scope of this tutorial)
          const user = JSON.parse(localStorage.getItem('currentUser'));
          if (parseInt(data.monto, 10) === 0) {
            that.montoPuja = that.subasta.precioBase;
          } else {
            that.montoPuja = parseInt(data.monto, 10) + 20000;
          }
          that.ultimoMontoPuja = parseInt(data.monto, 10);
          that.ultimoPujador = false;
          that.precioVentaFinal = data.monto;
          if (!(data.en_periodo_puja == null)) {
            that.enPeriodoPuja = data.en_periodo_puja;
          }
          if (!(data.en_periodo_compra_directa == null)) {
            that.enPeriodoCompraDirecta = data.en_periodo_compra_directa;
          }
          if (!(data.vendido == null)) {
            that.vendido = data.vendido;
          }
          if (!(data.en_periodo_aleatorio == null)) {
            that.enPeriodoAleatorio = data.en_periodo_aleatorio;
          }
          if (user) {
            that.ultimoPujador =
              data.id_ultimo_pujador === user.id ? true : false;
          }
          if (!(data.finalizado == null)) {
            that.finalizado = data.finalizado;
          }

          that.actualizarLabel();
          console.log(
            'New article published to category "' + topic + '" : ',
            data
          );
          that.getPujas();
        });
      },
      function () {
        that.subscripto = false;
        console.warn('WebSocket connection closed');
        setTimeout(() => that.subscribirWebSocket(id_lote, that), 5000);
      },
      { skipSubprotocolCheck: true }
    );
    that.conn = connLocal;
  }

  subscribirAPushNotifications(): any {
    this.swPush
      .requestSubscription({
        serverPublicKey: this.notificacionesPushService.VAPID_PUBLIC_KEY
      })
      .then(sub =>
        this.notificacionesPushService
          .agregarSubscriptorPush(sub)
          .subscribe(
            () => console.log('Se envió el objeto de suscripción al backend.'),
            err =>
              console.log(
                'No se pudo enviar el objeto de suscripción al backend, razón: ',
                err
              )
          )
      )
      .catch(err => {
        // tslint:disable-next-line:no-console
        console.debug(
          'Probar build y usar apache o comando http-server -p 8081 -c-1 dist/dobro/'
        );
        console.error('Navegador NO se pudo suscribir a notificaciones', err);
      });
  }

  ngOnDestroy() {
    if (this.subscripto) {
      this.conn.unsubscribe('lote_' + this.id);
      this.subscripto = false;
    }
    console.log('destroy!');
  }

  public separadorMiles(input) {
    const ret = input ? input.replace(/,/gi, '.') : null;
    return ret;
  }

  public callback($event) {
    return;
  }

  public getPujas() {
    if (localStorage.getItem('currentUser')) {
      if (
        this.permissionsService.hasPermission(
          'ROLE_ADMIN',
          JSON.parse(localStorage.getItem('currentUser'))
        )
      ) {
        console.log('GetPujas');
        this.id = this.route.snapshot.paramMap.get('id');
        this.subastasService
          .getSubastaGanador(this.id)
          .subscribe((data: Array<object>) => {
            return (this.ganador = data);
          });
        this.pujasService.getPujas(this.id).subscribe((data: Array<object>) => {
          return (this.pujas = data);
        });
      }
    }
  }

  public getSeguidoresLote() {
    if (localStorage.getItem('currentUser')) {
      if (
        this.permissionsService.hasPermission(
          'ROLE_ADMIN',
          JSON.parse(localStorage.getItem('currentUser'))
        )
      ) {
        this.id = this.route.snapshot.paramMap.get('id');
        this.subastasService
          .getSeguidoresLote(this.id)
          .subscribe((data: Array<Object>) => {
            return (this.seguidoresLote = data);
          });
      }
    }
  }
}
